/**
 * Leaderboard — Top-right panel showing player rankings by score.
 */

export interface LeaderboardEntry {
  username: string;
  score: number;
  kills: number;
  droneCount: number;
  isLocal: boolean;
}

const MAX_ROWS = 10;

interface RowCache {
  row: HTMLElement;
  rank: HTMLElement;
  name: HTMLElement;
  kills: HTMLElement;
  score: HTMLElement;
}

export class Leaderboard {
  private container: HTMLElement;
  private listEl: HTMLElement;
  private rowCache: RowCache[] = [];

  constructor(parentElement: HTMLElement) {
    this.container = document.createElement('div');
    this.container.className = 'hud-panel leaderboard hidden';

    const title = document.createElement('div');
    title.className = 'hud-panel-title';
    title.textContent = 'LEADERBOARD';
    this.container.appendChild(title);

    const header = document.createElement('div');
    header.className = 'leaderboard-header';
    for (const label of ['#', 'Name', 'K', 'Score']) {
      const span = document.createElement('span');
      span.textContent = label;
      header.appendChild(span);
    }
    this.container.appendChild(header);

    this.listEl = document.createElement('div');
    this.container.appendChild(this.listEl);

    // Pre-create row elements for reuse
    for (let i = 0; i < MAX_ROWS; i++) {
      const row = document.createElement('div');
      row.className = 'leaderboard-row';
      row.style.display = 'none';

      const rank = document.createElement('span');
      const name = document.createElement('span');
      const kills = document.createElement('span');
      const score = document.createElement('span');

      row.appendChild(rank);
      row.appendChild(name);
      row.appendChild(kills);
      row.appendChild(score);
      this.listEl.appendChild(row);

      this.rowCache.push({ row, rank, name, kills, score });
    }

    parentElement.appendChild(this.container);
  }

  /** Update cached rows with fresh data, sorted by score descending. */
  update(entries: LeaderboardEntry[]): void {
    const sorted = [...entries].sort((a, b) => b.score - a.score);
    const display = sorted.slice(0, MAX_ROWS);

    for (let i = 0; i < MAX_ROWS; i++) {
      const cache = this.rowCache[i];
      if (i < display.length) {
        const e = display[i];
        cache.row.style.display = '';
        cache.row.className = 'leaderboard-row' + (e.isLocal ? ' local-player' : '');
        cache.rank.textContent = String(i + 1);
        cache.name.textContent = e.username;
        cache.kills.textContent = String(e.kills);
        cache.score.textContent = String(e.score);
      } else {
        cache.row.style.display = 'none';
      }
    }
  }

  show(): void {
    this.container.classList.remove('hidden');
  }

  hide(): void {
    this.container.classList.add('hidden');
  }
}
